// src/components/ToastMessages/toastMessages.ts

const ToastMessages = {
  general: {
    success: {
      operationSuccess: 'Operação concluída com sucesso',
      dataSaved: 'Dados salvos com sucesso',
    },
    error: {
      genericError: 'Ocorreu um erro. Por favor, tente novamente mais tarde.',
      operationFailed: 'Falha na operação. Por favor, tente novamente',
      invalidInput: 'Entrada inválida. Por favor, verifique os campos',
      networkError: 'Erro de conexão. Por favor, tente novamente mais tarde',
      serverError: 'Erro do servidor. Por favor, tente novamente mais tarde',
    },
  },
  account: {
    success: {
      accountForgotPassword:
        'Verifique sua caixa de entrada. Enviamos um código token para prosseguir com a redefinição de senha',
      resetPassword: 'Senha alterada com sucesso!',
    },
    error: {
      accountForgotPassword:
        'Erro ao redefinir sua senha. Por favor, tente novamente',
      resetPassword:
        'Verifique o token e o e-mail se estão corretos ou tente novamente mais tarde',
    },
  },

  deliveries: {
    success: {
      getDelivery: 'Entregas disponíveis',
      getDeliveryEvent: 'Evento de entrega obtido com sucesso',
      patchDeliveryStatus: 'Status atualizado com sucesso',
      patchCartStatus: 'Status do volume atualizado com sucesso',
      patchReceiptStatus: 'Status do comprovante atualizado com sucesso',
    },
    error: {
      getDelivery:
        'Falha ao carregar as entregas. Por favor, tente novamente mais tarde',
      patchDeliveryStatus: 'Erro ao atualizar o status da entrega',
      patchCartStatus: 'Erro ao atualizar o status do volume',
      patchReceiptStatus: 'Erro ao atualizar o status do comprovante',
    },
  },
  distributor: {
    success: {
      deleteDistributor: 'Distribuidora deletada com sucesso',
      registerDistributor: 'Distribuidora registrada com sucesso',
      updateDistributor: 'Dados da distribuidora atualizados com sucesso',
    },
    error: {
      deleteDistributor: 'Falha ao deletar a distribuidora',
      registerDistributor: 'Falha ao registrar a distribuidora',
      updateDistributor: 'Falha ao atualizar os dados da distribuidora',
    },
  },

  distributorUser: {
    success: {
      registerDistributorUser: 'Usuário criado com sucesso',
      registerUserMaster:
        'Usuário Master criado! A senha foi enviada para o e-mail do usuário',
      deleteDistributorUser: 'Usuário deletado com sucesso',
      updateDistributorUser: 'Usuário atualizado com sucesso',
    },
    error: {
      registerDistributorUser: 'Falha ao registrar o usuário',
      deleteDistributorUser: 'Falha ao deletar o usuário',
      updateUser: 'Falha ao atualizar os dados do usuário',
      conflitUser: 'Usuário já cadastrado',
    },
  },

  driver: {
    success: {
      createMany: (count?: number) =>
        `Motorista(s) privado(s) ${
          count ? `(${count})` : ''
        } criado(s) com sucesso`,
      delete: 'Usuário deletado com sucesso',
      update: 'Usuário atualizado com sucesso',
    },
    error: {
      createMany: (message?: string) =>
        `Falha ao registrar motorista(s) privado(s)${
          message ? `: ${message}` : ''
        }`,
      delete: 'Falha ao deletar motorista privado',
      update: 'Falha ao atualizar os dados de motorista privado',
    },
  },
  vehicle: {
    success: {
      createMany: (count?: number) =>
        `Veículo(s) ${count ? `(${count})` : ''} criado(s) com sucesso`,
      delete: 'Veículo deletado com sucesso',
      update: 'Veículo atualizado com sucesso',
    },
    error: {
      createMany: (message?: string) =>
        `Falha ao registrar veículo(s)${message ? `: ${message}` : ''}`,
      delete: 'Falha ao deletar veículo',
      update: 'Falha ao atualizar os dados do veículo',
    },
  },

  refusedData: {
    success: {
      registerRefusedData: 'Motivos cadastrados com sucesso',
      updateRefuseData: 'Motivo de rejeição atualizado com sucesso',
    },
    error: {
      registerRefusedData: 'Falha ao registrar o motivo de rejeição',
      deleteDistributorUser: 'Falha ao deletar o usuário',
      updateRefuseData: 'Falha ao atualizar o motivo de rejeição',
    },
  },

  reasonRefusal: {
    success: {
      registerReasonRefusal: 'Motivo de recusa criado com sucesso',
      deleteReasonRefusal: 'Motivo de recusa deletado com sucesso',
      updateReasonRefusal: 'Motivo atualizado com sucesso',
    },
    error: {
      registerReasonRefusal: 'Falha ao cadastrar o motivo de recusa',
      deleteReasonRefusal: 'Falha ao deletar o motivo de recusa',
      updateReasonRefusal: 'Falha ao atualizar o motivo de recusa',
    },
  },

  freight: {
    success: {
      registerFreight: 'Frete registrado com sucesso',
      calculateFreight: 'Frete calculado com sucesso',
    },
  },

  mapping: {
    success: {
      registerMapping: 'Mapeamento criado com sucesso',
      updateMapping: 'Mapeamento atualizado com sucesso',
    },
    error: {
      registerMapping: 'Falha ao criar o mapeamento',
      updateMapping: 'Falha ao atualizar o mapeamento',
    },
  },

  vehicleType: {
    success: {
      deleteVehicleType: 'Tipo de veículo deletado com sucesso',
      registerVehicleType: 'Tipo de veículo cadastrado com sucesso',
      updateVehicleType: 'Tipo de veículo atualizado com sucesso',
    },
    error: {
      deleteVehicleType: 'Falha ao deletar o tipo de veículo',
      registerVehicleType:
        'Falha ao cadastrar o tipo de veículo. Verifique se já existe ou tente novamente mais tarde',
      updateVehicleType: 'Falha ao atualizar o tipo de veículo',
    },
  },
};

export default ToastMessages;
